import { render, staticRenderFns } from "./create-algo-data-details.html?vue&type=template&id=abf15442&scoped=true&external"
import script from "./create-algo-data-details.js?vue&type=script&lang=js&external"
export * from "./create-algo-data-details.js?vue&type=script&lang=js&external"
import style0 from "./create-algo-data-details.scss?vue&type=style&index=0&id=abf15442&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf15442",
  null
  
)

export default component.exports